import React, { useState, useEffect } from 'react';
import './TypewriterText.css';

const TypewriterText = ({ 
  lines = [], 
  speed = 50, 
  deleteSpeed = 30,
  delay = 1000, 
  pauseBetweenCycles = 2000,
  className = "",
  showCursor = true,
  cycle = false
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (lines.length === 0) return;

    const timer = setTimeout(() => {
      setIsTyping(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [lines, delay]);

  useEffect(() => {
    if (!isTyping || lines.length === 0 || isPaused) return;

    const currentLine = lines[currentLineIndex];
    
    if (!isDeleting) {
      // Typing phase
      if (currentCharIndex < currentLine.length) {
        const timer = setTimeout(() => {
          setDisplayText(prev => prev + currentLine[currentCharIndex]);
          setCurrentCharIndex(prev => prev + 1);
        }, speed);

        return () => clearTimeout(timer);
      } else {
        // Line is complete
        if (cycle && lines.length > 1) {
          // If cycling is enabled and we have multiple lines, pause then start deleting
          const timer = setTimeout(() => {
            setIsDeleting(true);
          }, pauseBetweenCycles);

          return () => clearTimeout(timer);
        } else if (!cycle && currentLineIndex < lines.length - 1) {
          // Non-cycling mode: move to next line
          const timer = setTimeout(() => {
            setDisplayText(prev => prev + '\n');
            setCurrentLineIndex(prev => prev + 1);
            setCurrentCharIndex(0);
          }, speed * 2);

          return () => clearTimeout(timer);
        }
      }
    } else {
      // Deleting phase
      if (displayText.length > 0) {
        const timer = setTimeout(() => {
          setDisplayText(prev => prev.slice(0, -1));
        }, deleteSpeed);

        return () => clearTimeout(timer);
      } else {
        // Deletion complete, move to next line and start typing
        setIsDeleting(false);
        setCurrentLineIndex(prev => (prev + 1) % lines.length);
        setCurrentCharIndex(0);
      }
    }
  }, [currentCharIndex, currentLineIndex, lines, speed, deleteSpeed, pauseBetweenCycles, isTyping, isDeleting, displayText, cycle, isPaused]);

  const formatText = (text) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className={`typewriter-container ${className}`}>
      <span className="typewriter-text">
        {formatText(displayText)}
        {showCursor && <span className="typewriter-cursor"></span>}
      </span>
    </div>
  );
};

export default TypewriterText; 